import React from 'react'
import { useNavigate } from 'react-router-dom'
import { AppBar } from '../common/components/AppBar'
import { Toolbar } from '../common/components/Toolbar'
import { IconButton } from '../common/components/IconButton'
import { ArrowBackIcon } from '../common/components/icons/ArrowBackIcon'
import { Icons } from '@botsquad/web-client'

import AppState from './state'

export interface NavBarProps {
  title?: string
  hasUnread?: boolean
}

const NavBar: React.FC<NavBarProps> = ({ title, hasUnread }) => {
  const navigate = useNavigate()
  const goBack = () => navigate('/')

  if (AppState.isEmbedded()) {
    if (!AppState.showBackButton()) {
      return null
    }
    return (
      <div className="embedded-nav">
        <span className="btn" onClick={goBack}>
          {Icons.Conversations}
          {hasUnread ? <span className="has-unread" /> : null}
        </span>
      </div>
    )
  }

  return (
    <div className="nav-bar--wrapper">
      <AppBar position="static">
        <Toolbar>
          {AppState.showBackButton() ? (
            <IconButton className="nav-bar--menu-button" onClick={goBack} color="inherit" aria-label="Menu">
              <ArrowBackIcon />
            </IconButton>
          ) : null}
          <div className="nav-bar--flex">
            <h6 className="nav-bar--title">{title}</h6>
          </div>
        </Toolbar>
      </AppBar>
    </div>
  )
}

export default NavBar
